import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CreditSetupResponse, CreditSetupStatus } from '@brightside-web/desktop/data-access/shared';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VerifyOtpGuard implements CanActivate {
  constructor(private router: Router, private creditSetupService: CreditSetupService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.creditSetupService.getSetupStatus().pipe(
      map((resp: CreditSetupResponse) => {
        if (resp.status === CreditSetupStatus.VERIFY_OTP) {
          return true;
        } else if (resp.status === CreditSetupStatus.VERIFY_KBA) {
          this.router.navigate(['credit-setup', 'verify', 'kba', 'intro']);
          return false;
        }

        return false;
      })
    );
  }
}
